import React, { useState, useCallback, useMemo } from 'react';
import { Formik, useField } from 'formik';
import { Grid, Typography, Box, Button, Slider, TextField as MUITextField, IconButton, DialogActions, DialogTitle, List, ListItem, ListItemText } from '@mui/material';
import { fetchJSON, postCommand, useRefresh } from '../../data/fetch';
import { COMMAND } from '../../../common';
import { TextField, ToggleField, Autocomplete, DateField, EnumField } from '../../components/input';


export default function DeleteGLSDialog(props) {
  let { rec } = props.open;
  let refresh = useRefresh();
  const submit = async () => {
    let ret = await fetchJSON('POST', '/delivery/gls/delete/' + rec.id);
    if (ret && ret.error) {
      alert(ret.error);
    } else {
      refresh();
      props.close();
    }
  }

  return (<>
      <DialogTitle>GLS címkék törlése</DialogTitle>
      <Typography sx={{ p: 2 }}>
        Biztosan törölni szeretné a következő GLS címkéket? <br/>
        <b>{rec.trackingnr}</b>
        <br/>
        Ez a művelet visszafordíthatatlan.
        A szállítmányt a GLS-nél lemondjuk.        
      </Typography>
      <DialogActions>
        <Button sx={{ color: "text.secondary" }} onClick={() => props.cancel()}>Mégsem</Button>
        <Button variant="contained" type="submit" onClick={submit}>GLS címkék törlése</Button>
      </DialogActions>
  </>)
}